import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";

@Component({
  selector: "kpi-commissions-earnings",
  templateUrl: "./kpi-commissions-earnings.component.html",
  styleUrls: ["./kpi-commissions-earnings.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KpiCommissionsEarningsComponent {
  @Input() resources$: Observable<any>;

  constructor(private router: Router) {}

  navigateToObject(eaOid: string, event: Event): void {
    event.preventDefault();
    this.router.navigate([
      "/crm",
      {
        outlets: {
          primary: ["showings", eaOid],
          sidebar: null,
          modal: null,
        },
      },
    ]);
  }
}
